import { cn } from '@/lib/utils';

/** Renders stored rich-text HTML with sensible inline styling. */
export function RichText({ html, className }: { html: string; className?: string }) {
  return (
    <div
      className={cn(
        'text-sm',
        '[&_p]:mb-2 [&_p:last-child]:mb-0',
        '[&_ul]:mb-2 [&_ul]:list-disc [&_ul]:pl-5',
        '[&_ol]:mb-2 [&_ol]:list-decimal [&_ol]:pl-5',
        '[&_a]:underline [&_a]:underline-offset-2',
        '[&_strong]:font-semibold',
        className,
      )}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: admin-authored content
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
